import {FC} from 'react'
import {PrintFlowOutcome, StageStatus} from '../printFlow/outcomeModel'

const stageIcon = (status: StageStatus) => {
  switch (status) {
    case 'complete':
      return {glyph: '✓', className: 'bg-success text-white'}
    case 'sent_unconfirmed':
    case 'sent_timed_out':
      return {glyph: '◐', className: 'bg-primary text-white'}
    case 'not_requested':
    case 'na':
      return {glyph: '○', className: 'bg-light text-gray-600'}
    case 'failed':
      return {glyph: '✕', className: 'bg-danger text-white'}
    case 'partial':
    case 'pending':
      return {glyph: '…', className: 'bg-warning text-white'}
    default:
      return {glyph: '?', className: 'bg-secondary text-white'}
  }
}

type Props = {outcome: PrintFlowOutcome}

export const OperationalStageFlow: FC<Props> = ({outcome}) => (
  <div className='card card-flush border border-gray-200 mb-6'>
    <div className='card-header border-0 pt-5 pb-0'>
      <div className='card-title flex-column align-items-start'>
        <span className='fw-bold text-gray-800'>What happened?</span>
        <span className='text-muted fs-7 fw-semibold mt-1'>Operational path from content to result</span>
      </div>
    </div>
    <div className='card-body pt-5'>
      <div className='d-flex flex-wrap gap-3 mb-6'>
        {outcome.stages.map((stage, index) => {
          const icon = stageIcon(stage.status)
          return (
            <div key={stage.key} className='d-flex align-items-center gap-3'>
              <div className='text-center' style={{minWidth: 92}}>
                <div
                  className={`rounded-circle d-inline-flex align-items-center justify-content-center mb-2 ${icon.className}`}
                  style={{width: 32, height: 32}}
                >
                  {icon.glyph}
                </div>
                <div className='fw-bold text-gray-800 fs-8 text-uppercase'>{stage.label}</div>
                <div className='text-gray-700 fs-8'>{stage.statusLabel}</div>
              </div>
              {index < outcome.stages.length - 1 && (
                <div className='text-muted fw-bold d-none d-md-block'>→</div>
              )}
            </div>
          )
        })}
      </div>

      <div className='d-flex flex-column gap-4'>
        {outcome.stages.map((stage) => (
          <div key={`${stage.key}-detail`}>
            <div className='d-flex align-items-center justify-content-between gap-3 mb-1'>
              <span className='fw-bold text-gray-800 fs-7'>{stage.label}</span>
              <span className='badge badge-light'>{stage.statusLabel}</span>
            </div>
            <div className='text-gray-700 fs-6'>{stage.explanation}</div>
          </div>
        ))}
      </div>
    </div>
  </div>
)
